import axios from '@/libs/api.request'

export const getTestimonialsinfolist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/testimonialsinfo/testimonialsinfo/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const operationTestimonialsinfo = (data, meth) => {
  return axios.request({
    url: '/v1/testimonialsinfo/testimonialsinfo/',
    method: meth,
    data
  })
}